import React from "react";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

export default function GeneratePDF({ targetId, fileName = "brochure.pdf" }) {
  const handleDownload = async () => {
    const container = document.getElementById(targetId);

    if (!container) {
      alert("Target element not found");
      return;
    }

    const sections = container.querySelectorAll(".pdf-section");

    const pdf = new jsPDF("p", "mm", "a4");
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = pdf.internal.pageSize.getHeight();

    for (let i = 0; i < sections.length; i++) {
      const section = sections[i];

      const canvas = await html2canvas(section, {
        scale: 2,
        useCORS: true,
      });

      const imgData = canvas.toDataURL("image/png");

      const imgWidth = pdfWidth;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      let heightLeft = imgHeight;
      let position = 0;

      if (i !== 0) {
        pdf.addPage();
      }

      pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
      heightLeft -= pdfHeight;

      // If section itself is longer than one page
      while (heightLeft > 0) {
        position = heightLeft - imgHeight;
        pdf.addPage();
        pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
        heightLeft -= pdfHeight;
      }
    }

    pdf.save(fileName);
  };

  return (
    <button
      onClick={handleDownload}
      style={{
        padding: "12px 20px",
        background: "#0f172a",
        color: "#fff",
        border: "none",
        borderRadius: "6px",
        cursor: "pointer",
      }}
    >
      Download PDF
    </button>
  );
}
